import { useState } from 'react';
import {
  Link,
} from '@material-ui/core';

import { console_log, getGoogleDrivenTime } from '../helpers/untils';
import { useEffect } from 'react';


const GoogleDrivenTimeBox = (props) => {
  const { lat, lng, destinationsLocation, autoShow = false, label = "Driven Time", facility = {} } = props
  console_log(`GoogleDrivenTimeBox, destinationsLocation:::`, destinationsLocation);

  //////////////////////////////////////////////////////////////
  const [drivenTime, setDrivenTime] = useState("...")
  const showDrivenTime = async () => {
    console_log(`showDrivenTime:::::`)
    const originsLocation = { lat, lng }
    const aa = await getGoogleDrivenTime(originsLocation, destinationsLocation, facility)
    setDrivenTime(aa)
  }

  // const fetchDrivenTime = useCallback(async () => {
  //   try {
  //     await showDrivenTime()
  //   } catch (err) {
  //     console.error("Failed to fetch user:", err);
  //   }
  // }, [lat, lng, destinationsLocation, autoShow]);

  useEffect(() => {
    if (lat && lng && destinationsLocation && autoShow) {
      showDrivenTime()
    }
  }, [lat, lng, destinationsLocation, autoShow])
  //////////////////////////////////////////////////////////////

  return (
    <>
      {
        (autoShow) ? (
          <>
            {`${drivenTime} Away`}
          </>
        ) : (
          <>
            {
              (drivenTime) ? (
                <>
                  {`${drivenTime} Away`}
                </>
              ) : (
                <>
                  <Link onClick={() => showDrivenTime()} style={{ cursor: 'pointer', color: '#1366ff' }}>{label}</Link>
                </>
              )
            }
          </>
        )
      }
    </>
  );
};

export default GoogleDrivenTimeBox;
